export default __webpack_public_path__ + "static/media/happyFaceEmoji.d723ce46.svg";